import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const conditionWatcher = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    boundaryEventId: z
      .string()
      .describe('The boundary event that created this watcher'),

    conditionExpression: z
      .string()
      .describe(
        'The compiled JavaScript expression to evaluate against process instance data',
      ),

    status: options([
      { value: 'Active', name: 'Active' },
      { value: 'Paused', name: 'Paused' },
      { value: 'Complete', name: 'Complete' },
      { value: 'Canceled', name: 'Canceled' },
    ])
      .nullable()
      .optional()
      .describe('Current state of this watcher'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    token: belongsTo('Token'),

    tenant: references('Tenant'),
  })
  .describe(
    'Monitors a condition expression against process instance data and fires when the condition becomes true',
  )
  .as('ConditionWatcher');

export { conditionWatcher as conditionWatcherSchema };
